import React from 'react';

function Achievements() {
  return (
    <div>
      <hr />
      <h2>Achievements and Certifications</h2>
      <p id='spacing'>
      <ul>
        <li><b>A.Y. 2023-24</b>
          <ol>
            <li>Awarded the Master of Computer Science Degree at Chicago, in the State of Illinois, USA.</li>
            <li>Completed the Complete UiPath RPA Developer Course: Build 7 Robots online course on <a href='https://www.udemy.com/certificate/UC-bb868818-d77f-4b4b-848c-61bdc98ab279/'>Udemy</a>.</li>
            <li>Successfully completed Yoga Prana Vidya Level 1 Workshop.</li>
          </ol>
        </li>
        <br />

        <li><b>A.Y. 2020 - 21:</b>
          <ol>
            <li>Recognition for resolving highest support tickets.</li>
          </ol>
        </li>
        <br />

        <li><b>A.Y. 2019 - 20:</b>
          <ol>
            <li>Awarded "Rising Star" for initiating and successfully leading the Job Monitoring Sheet Automation project at Colgate Global Business Services Private Limited.</li>
            <li>Conferred the degree of Bachelor of Technology in Information Technology under the Faculty of Science and Technology with the 'A+' Grade.</li>
            <li>Received the Operational Excellence and Technology & Innovation Excellence Award for automating critical business processes and improving SAP system performance at Colgate Global Business Services Private Limited.</li>
            <li>Successfully completed the Advanced Google App Script and API Calls online course on <a href='https://www.udemy.com/certificate/UC-499UGUW9/'>Udemy</a>.</li>
            <li>Successfully completed the Learn Google App Script: From Level Zero online course on <a href='https://www.udemy.com/certificate/UC-JMVF7LU4/'>Udemy</a>.</li>
          </ol>
        </li>
        <br />

        <li><b>A.Y. 2018 - 19:</b>
          <ol>
            <li>Won 1st Prize in Project Exhibition and Competition for Smart Building System using IoT at Usha Mittal Institute of Technology.</li>
            <li>Completed project-based online course of 5 IoT Projects (Combo Course) from <a href='https://www.skyfilabs.com/'>SkyfiLabs</a> and <a href='https://www.roboversity.com/'>Roboversity</a>.</li>
          </ol>
        </li>
        <br />

        <li><b>A.Y. 2016 - 18:</b>
          <ol><li>Executive General Secretary at SNDT ACM Students' Chapter, Mumbai, India (May 2016 -- Sept. 2018).</li>
            <li>Diploma in Software Engineering- Java Specialization from National Institute of Information Technology (NIIT), Mumbai, India (Dec. 2016 -- June 2017).</li>
          </ol>
        </li>
      </ul>
      </p>
    </div>
  );
}

export default Achievements;